import React, { createContext, FC, useState } from "react";
import { SidebarContextType } from "../types/sidebar";

export const SidebarContext = createContext<SidebarContextType | null>(null);

export const SideBarProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isSideBarOpen, setSidebarOpen] = useState(false);

  const openSideBar = () => setSidebarOpen(true);
  const closeSideBar = () => {
    console.log("s");
    setSidebarOpen(false);
  };

  return (
    <SidebarContext.Provider
      value={{
        isSideBarOpen,
        openSideBar,
        closeSideBar,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
